import axios from 'axios'

export default {
  namespaced: true,
  state: {
    allContentData: {},
    contentData: {},
    categoryContentData: {},
  },
  getters: {
    contentData: (state) => {
      return state.contentData
    },
    allContentData: (state) => {
      return state.allContentData
    },
    categoryContentData: (state) => {
      return state.categoryContentData
    },
  },
  mutations: {
    setContentData(state, payload) {
      state.contentData = payload
    },
    setAllContentData(state, payload) {
      state.allContentData = payload
    },
    setCategoryContentData(state, payload) {
      state.categoryContentData = payload
    },
  },
  actions: {
    onGetContentData({commit, rootState}, {limit, page, filter}) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/content/grid?limit=' +
        limit +
        '&page=' +
        page +
        '&filter[]=category:' +
        filter
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setAllContentData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onShowContentData({commit, rootState}, {id}) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/content/' + id
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setContentData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onGetCategoryContent({commit, rootState}, {category, contentable_type, contentable_id}) {
      let url =
        rootState.apiDomain +
        '/api/admin/common/content/category?category=' +
        category +
        '&contentable_type=' +
        contentable_type +
        '&contentable_id=' +
        contentable_id
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: 'GET',
        })
          .then((resp) => {
            commit('setCategoryContentData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onChangeContentData({rootState}, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/common/content',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
